// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K9Rp","rootMobile":"styles_rootMobile__3KJO8"};